<template>
  <v-container class="pa-6">
    <v-row>
      <v-col cols="3">
        <v-select
          solo
          dense
          :value="selectedMonths"
          @change="filterBasedOnMonth"
          label="Month"
          multiple
          :items="months"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip x-small v-if="index < 2"> {{ item.text }} </v-chip>
            <span class="grey--text text-caption" v-if="index == 2"> + {{ selectedMonths.length - index }} more</span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field solo dense label="Search" single-line hide-details v-model="search" />
      </v-col>
    </v-row>
    <v-data-table
      :loading="loading"
      item-key="location_id"
      :headers="headers"
      :search="search"
      :items="filteredData"
      :items-per-page="10"
      sort-by="logged_at"
      :sort-desc="true"
    >
    </v-data-table>
  </v-container>
</template>

<script>
import { extractDataAxios } from "@/httpClient";
import { MONTHS } from "@/constants";

export default {
  name: "Userlogs",
  async mounted() {
    this.loading = true;
    let response = null;
    if (this.id) {
      response = extractDataAxios(await window.axios.get(`/api/user/${this.id}/logs`));
    } else {
      response = extractDataAxios(await window.axios.get("/api/user/all/logs"));
    }
    this.locationData = response.locations;
    this.loading = false;
  },
  props: {
    id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Company Name",
          value: "company_name",
        },
        {
          text: "Registered Location",
          value: "registered_location",
        },
        {
          text: "Logged in at",
          value: "logged_at",
        },
        {
          text: "Location",
          value: "location",
        },
      ],
      locationData: [],
      search: "",
      months: MONTHS,
      loading: false,
      selectedMonths: [],
    };
  },
  methods: {
    filterBasedOnMonth(item) {
      this.selectedMonths = item;
    },
  },
  computed: {
    filteredData() {
      this.locationData.forEach((aLocation) => {
        if (aLocation.location.toLowerCase().includes("unknown")) {
          aLocation.location = "Unknown";
        }
      });
      if (this.selectedMonths.length > 0) {
        return this.locationData.filter((aLocation) => this.selectedMonths.includes(aLocation.logged_at.split("-")[1]));
      }
      return this.locationData;
    },
  },
};
</script>

<style></style>
